import { makeAutoObservable } from "mobx";
import { ProductInstancePart } from "../ProductInstance";
import { IdentifiableMap } from "../../collections";
/*
 * Utility class for building correct `ProductInstancePart` - it deals with changing productTypes in halves
 */
export class ProductInstanceCreatorPart {
    constructor(params) {
        this.productType = params.productType;
        this.modifierInstanceCreators = params.modifierInstanceCreators;
        makeAutoObservable(this);
    }
    get productTypeId() {
        return this.productType.id;
    }
    get productInstancePart() {
        return new ProductInstancePart({
            productType: this.productType,
            modifierInstances: new IdentifiableMap(this.modifierInstanceCreators.raw.map((c) => c.modifierInstance)),
        });
    }
    selectInferredDefaults() {
        this.modifierInstanceCreators.objects.forEach((m) => m.selectInferredDefaults());
    }
}
